import { render, staticRenderFns } from "./paychecks.vue?vue&type=template&id=28861410&scoped=true&"
import script from "./paychecks.vue?vue&type=script&lang=ts&"
export * from "./paychecks.vue?vue&type=script&lang=ts&"
import style0 from "./paychecks.vue?vue&type=style&index=0&id=28861410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28861410",
  null
  
)

export default component.exports